"use client";

import { util } from "@/common/theme";
import CustomSplitText from "@/mono/components/CustomSplitText";
import { mediaMobile } from "@/mono/lib/responsive";
import styled from "styled-components";
import { convertMultiParagraphToNineFormat } from "./MultiLineTextComponent";
import SplitText from "mono/components/SplitText";

export default function Paragraph({ data: { content } }) {
  const formattedParagraph = convertMultiParagraphToNineFormat(content);
  return (
    <Wrapper>
      <div className="paragraph-inner">
        {formattedParagraph.map((p, i) => (
          <SplitText key={i} tag={p.tag} animateOnScroll={true}>
            {p.text}
          </SplitText>
        ))}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${util.innerWidth}

  padding-top: 200rem;
  padding-bottom: 200rem;

  display: flex;
  justify-content: center;

  .paragraph-inner {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    max-width: 50%;

    gap: 50rem;
  }

  p {
  }

  ${mediaMobile(`
    .paragraph-inner {
      max-width: 100%;
    }

    p {
      max-width: 100%;
      width: 100%;
    }
  `)}
`;
